module.exports = __webpack_public_path__ + "img/messages.2d28dd6b.svg";